<template>
    <span class="text-primary">{{ timerText }}</span>
</template>

<script>
export default {
    name: 'CountDownTimer',
    props: {
        time: {
            type: Number,
            required: true,
        },
        startTimer: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            innerTime: '',
            timerText: '',
            timer: '',
        }
    },
    watch: {
        startTimer(val) {
            if (!val) {
                clearInterval(this.timer)
                this.innerTime = this.time
            } else {
                this.start()
            }
        },
    },
    mounted() {
        this.innerTime = this.time
        if (this.startTimer) {
            this.start()
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {
        start() {
            clearInterval(this.timer)
            const vm = this
            let timer = this.innerTime
            let minutes
            let seconds
            this.timer = setInterval(function () {
                minutes = parseInt(timer / 60, 10)
                seconds = parseInt(timer % 60, 10)
                minutes = minutes < 10 ? '0' + minutes : minutes
                seconds = seconds < 10 ? '0' + seconds : seconds
                vm.timerText = minutes + ':' + seconds
                vm.innerTime = timer
                if (timer - 1 >= 0) {
                    timer--
                } else {
                    vm.$emit('end_call_back')
                }
            }, 1000)
        },
    },
}
</script>
